// src/redux/tesisatSlice.js
//
// Tesisat (priz, anahtar, armatür, buat, kablo bacası, vb.) görsel meta katmanı.
// Elektriksel data simpleSupply.components'te kalır; bu slice yalnızca mesh
// rebuild için gereken alanları (position, type, subtype, rotation, ...) tutar.
//
// JBZ load akışında scene-objects.json'dan Three.js mesh restore başarısız olduğu
// için (NaN geometry / kayıp child referansları) burada tutulan veri,
// useTesisatRebuild hook'u tarafından factory fonksiyonlarıyla yeniden inşa edilir.

import { createSlice, createSelector } from '@reduxjs/toolkit';

const initialState = {
  byId: {},   // { id: { id, type, subtype, position, rotation, ... factory-specific fields } }
  allIds: [],
};

const tesisatSlice = createSlice({
  name: 'tesisat',
  initialState,
  reducers: {
    addTesisat: (state, action) => {
      const item = action.payload;
      if (!item || !item.id) return;
      if (state.byId[item.id]) {
        // Idempotent: aynı id varsa shallow merge (interactive ↔ rebuild yarışı için)
        state.byId[item.id] = { ...state.byId[item.id], ...item };
        return;
      }
      state.byId[item.id] = item;
      state.allIds.push(item.id);
    },

    updateTesisat: (state, action) => {
      const { id, changes } = action.payload || {};
      if (!id || !state.byId[id]) return;
      state.byId[id] = { ...state.byId[id], ...changes };
    },

    deleteTesisat: (state, action) => {
      const id = action.payload;
      if (!id || !state.byId[id]) return;
      delete state.byId[id];
      state.allIds = state.allIds.filter(x => x !== id);
    },

    clearTesisat: (state) => {
      state.byId = {};
      state.allIds = [];
    },
  },
});

export const { addTesisat, updateTesisat, deleteTesisat, clearTesisat } = tesisatSlice.actions;
export default tesisatSlice.reducer;

// ── Selectors ──────────────────────────────────────────────────────────────

const selectById = (s) => s.tesisat?.byId || {};
const selectAllIds = (s) => s.tesisat?.allIds || [];

export const selectAllTesisat = createSelector(
  [selectAllIds, selectById],
  (allIds, byId) => allIds.map(id => byId[id]).filter(Boolean)
);

export const selectTesisatById = (state, id) => state.tesisat?.byId?.[id] || null;

export const selectTesisatByType = (type) => createSelector(
  [selectAllTesisat],
  (all) => all.filter(item => item && item.type === type)
);

export const selectTesisatByFloorPlan = (floorPlanId) => createSelector(
  [selectAllTesisat],
  (all) => all.filter(item => item && item.floorPlanId === floorPlanId)
);
